import { useCallback, useState } from "react";
import CustomSnackBar from "../shared/CustomSnackBar";

const useSnackBar = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("success");

  const handleCloseSnackBar = () => {
    setOpen(false);
  };

  const handleSuccess = useCallback((message) => {
    setMessage(message);
    setOpen(true);
    setStatus("success");
  }, []);

  const handleError = useCallback((message) => {
    setMessage(message);
    setOpen(true);
    setStatus("failure");
  }, []);

  return {
    open,
    message,
    status,
    success: handleSuccess,
    error: handleError,
    snackbar: (
      <CustomSnackBar
        open={open}
        message={message}
        status={status}
        onClose={handleCloseSnackBar}
      />
    ),
  };
};

export default useSnackBar;
